import { Route, Routes } from "react-router-dom";
import Onboarding from "src/scenes/Onboarding";
import Welcome from "src/scenes/Welcome";
import Dashboard from "src/scenes/Dashboard";
import ParentStation from "src/modules/parent-station/ParentStation";
import BabyStation from "src/modules/baby-station/BabyStation";
import { LoginAsRoute } from "src/modules/auth/scenes/Login";
import HowItWorks from "src/scenes/HowItWorks";
import SplashScreen from "src/scenes/SplashScreen";
import DeviceInstall from "src/scenes/DeviceInstall";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/device-install/:id" element={<DeviceInstall />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/login" element={<LoginAsRoute />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/baby-station" element={<BabyStation />} />
      <Route path="/parent-station" element={<ParentStation />} />
    </Routes>
  );
}
